import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=01295772&scoped=true"
import script from "./transport.vue?vue&type=script&lang=js"
export * from "./transport.vue?vue&type=script&lang=js"
import style0 from "./transport.vue?vue&type=style&index=0&id=01295772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01295772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VCard,VContainer,VList,VListItem,VListItemTitle,VMenu,VPagination})
